import {Location} from '@angular/common';
import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'form-page-button-block',
    templateUrl: 'form-page-button-block.html'
})
export class FormPageButtonBlockWidget {
    @Input() showSave:boolean = true;
    @Input() cancelText:string = 'general.cancel';
    @Input() goBackLink:string;

    constructor(private location: Location, private router: Router){
    }

    public back() {
        if (this.goBackLink) {
            if (this.goBackLink.includes('http') || this.goBackLink.includes('https')) {
                window.location.href = this.goBackLink;
            } else {
                this.router.navigate([this.goBackLink])
            }
        } else {
            this.location.back()
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/widgets/form-page-button-block/form-page-button-block.component.ts